import React from "react";
import "./EmailSent.scss";
import { SVG, Text, NoData, Button } from "sunrise-ui";
import { Box, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { postForgotPasswordData } from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const EmailSent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [resend, setResend] = React.useState(false);
  const [resendClicked, setResendClicked] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const navigate = useNavigate();
  const location: any = useLocation();
  const forgotPasswordData = useSelector(
    (state: any) => state.USERS.forgotPasswordData
  );

  React.useEffect(() => {
    setEmail(location.state.email);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (forgotPasswordData?.status === 1) {
      if (resendClicked) {
        setResend(true); // setting true if resend link is clicked to show the link sent message.
      }
    }
    // eslint-disable-next-line
  }, [forgotPasswordData]);

  const resentMail = () => {
    setResendClicked(true);
    let obj = {
      email: email,
    };
    dispatch(postForgotPasswordData({ endPoint: "forgetPassword", data: obj }));
  };

  return (
    <Box className="admin_forgot_wrapper">
      <Grid container>
        <Grid item xs={12}>
          <Grid className="d-flex h-center v-center pt1 pb1">
            <Grid>
              <SVG type="title" />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={5}
          xs={12}
          className="image_box d-flex h-center v-center"
        >
          <Grid>
            <NoData
              img="forgotPasswordImage"
              text="We have got your password. Don't worry just send your request."
            />
          </Grid>
        </Grid>
        <Grid
          item
          md={7}
          xs={12}
          className="forgot_col d-flex h-center v-center"
        >
          <Grid container className="forgot_box bg--white p2">
            <Grid item xs={12}>
              <Grid className="mb1">
                <Text
                  type={"normal"}
                  fontSize={24}
                  fonts={"normal"}
                  className="mb mt0 fw500"
                >
                  Email has been sent!
                </Text>
                <Text
                  type={"normal"}
                  fontSize={20}
                  fonts={"normal"}
                  className="fw400 mb0 mt0"
                >
                  Please check your inbox to see your password.
                </Text>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid className="mt1">
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="primary"
                  onClick={() => navigate("/")}
                  className="w100 login_button"
                >
                  Login
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid className="mt2 d-flex h-center">
                {resend ? (
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={20}
                    className="mt0 mb0 mr-1"
                  >
                    <span>Please check your inbox to see your password. </span>
                  </Text>
                ) : (
                  <>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={20}
                      className="mt0 mb0 mr-1"
                    >
                      <span>Didn't receive the link? </span>
                    </Text>
                    <Text
                      type="link"
                      fonts="normal"
                      fontSize={20}
                      onTextClick={() => {
                        resentMail();
                      }}
                    >
                      <span className="fw600">Resend</span>
                    </Text>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmailSent;
